<template>
  <BNavbar class="text-white" variant="primary" fixed="top" data-bs-theme="dark">
    <slot></slot>
    <BNavbarNav class="ms-auto text-white">
      <BNavItem to="/"><Icon icon="bi:house-door-fill" style="font-size: 20px"/></BNavItem>
      <BNavItem id="login"><Icon icon="bi:person-x" style="font-size: 20px" /></BNavItem>
    </BNavbarNav>
  </BNavbar>
</template>

<script setup lang="ts">
import { BNavbar, BNavbarNav, BNavItem } from 'bootstrap-vue-next'
import { Icon } from '@iconify/vue'

</script>

<style lang="scss">
@import '../main.scss';

.navbar {
  small {
    font-size: 11px;
    line-height: 1;
    margin-left: 2em;
  }

  .navbar-brand {
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 1.2;
  }

  .navbar-nav {
    align-items: center;

    .nav-link {
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 0.75);

      &:hover, &.active {
        color: #fff;
      }

      &.btn-light {
        color: #333;
      }
    }
  }
}

.offcanvas {
  .nav {
    li.form-inline {
      display: block;
    }

    .form-inline.block {
      display: block;

      .form-group {
        display: block;
        margin-bottom: 1rem;
      }

      .btn-group-vertical {
        width: 100%;

        label {
          display: block;
          text-align: left;
        }
      }
    }
  }
}
</style>
